import { render, staticRenderFns } from "./img-box.vue?vue&type=template&id=416d35e2&scoped=true&"
import script from "./img-box.vue?vue&type=script&lang=ts&"
export * from "./img-box.vue?vue&type=script&lang=ts&"
import style0 from "./img-box.vue?vue&type=style&index=0&id=416d35e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d35e2",
  null
  
)

export default component.exports